import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API}/api`,
});

// Attach bearer token as a fallback (cookies preferred, but useful for cross-site)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("crm_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
